/* models/canvas/index.js */ function _(require, module, exports) {
    var canvas_1 = require(274) /* ./canvas */;
    exports.Canvas = canvas_1.Canvas;
    var cartesian_frame_1 = require(278) /* ./cartesian_frame */;
    exports.CartesianFrame = cartesian_frame_1.CartesianFrame;
}
